<h1 mat-dialog-title>Edit Basic Info</h1>
<div mat-dialog-content>
    <div class="row m-2">
        <form class="col-sm-12 row" [formGroup]="basicInfoForm">
            <div class="col-sm-12 col-md-6 form-group">
                <label for="iam" class="w-100">I am</label>
                <div class="row ml-2" id="iam">
                    <div class="col-sm-6">
                        <input class="form-check-input" type="radio" formControlName="iam" id="agent" value="Agent">
                        <label class="form-check-label" for="agent">
                            Agent
                        </label>
                    </div>
                    <div class="col-sm-6">
                        <input class="form-check-input" type="radio" formControlName="iam" id="owner" value="Owner">
                        <label class="form-check-label" for="owner">
                            Owner
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 form-group">
                <label for="listing_for" class="w-100">List My Property For</label>
                <div class="row ml-2" id="listing_for">
                    <div class="col-sm-4">
                        <input class="form-check-input" type="radio" id="sell" formControlName="listingFor" value="Sell">
                        <label class="form-check-label" for="agent">
                            Sell
                        </label>
                    </div>
                    <div class="col-sm-4">
                        <input class="form-check-input" type="radio" id="rent" formControlName="listingFor" value="Rent">
                        <label class="form-check-label" for="rent">
                            Rent
                        </label>
                    </div>
                    <div class="col-sm-4">
                        <input class="form-check-input" type="radio" id="share" formControlName="listingFor" value="Share">
                        <label class="form-check-label" for="share">
                            Share
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 form-group">
                <label for="property_type">Property Type</label>
                <select class="form-control" id="property_type" formControlName="property_type_id">
                    <option value="null" disabled [selected]="true">Choose the type of property</option>
                    <option *ngFor="let type of propertyTypes" [value]="type.id">{{ type.type }}</option>
                </select>
            </div>
            <div class="col-sm-6 form-group">
                <label for="distFromRoad">Distance From Road</label>
                <div class="unit-holder-main">
                    <input class="form-control unit-holder" id="distFromRoad" formControlName="distFromRoad" type="number" placeholder="Distance From Road">
                    <div class="unit">
                        <select class="small-unit form-control unit-select" [(ngModel)]="selectedUnitDistance" [ngModelOptions]="{standalone: true}">
                            <option value="Meter">Meter</option>
                            <option value="Feet">Feet</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 form-group">
                <label for="totalArea">Total Area (B-K-D-K)</label>
                <div class="d-flex align-items-center">
                    <div class="text-center mr-1 flex-fill">
                        <input type="number" min="0" class="form-control text-center p-1" formControlName="bigha" (input)="updateTotalArea()" placeholder="0">
                        <small class="text-muted d-block">Bigha</small>
                    </div>
                    <span class="font-weight-bold mb-3">-</span>
                    <div class="text-center mx-1 flex-fill">
                        <input type="number" min="0" class="form-control text-center p-1" formControlName="kattha" (input)="updateTotalArea()" placeholder="0">
                        <small class="text-muted d-block">Kattha</small>
                    </div>
                    <span class="font-weight-bold mb-3">-</span>
                    <div class="text-center mx-1 flex-fill">
                        <input type="number" min="0" class="form-control text-center p-1" formControlName="dhur" (input)="updateTotalArea()" placeholder="0">
                        <small class="text-muted d-block">Dhur</small>
                    </div>
                    <span class="font-weight-bold mb-3">-</span>
                    <div class="text-center ml-1 flex-fill">
                        <input type="number" min="0" class="form-control text-center p-1" formControlName="kanwa" (input)="updateTotalArea()" placeholder="0">
                        <small class="text-muted d-block">Kanwa</small>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 form-group">
                <label for="houseArea">House Area (R-A-P-D)</label>
                <div class="d-flex align-items-center">
                    <div class="text-center mr-1 flex-fill">
                        <input type="number" min="0" class="form-control text-center p-1" formControlName="ropani" (input)="updateHouseArea()" placeholder="0">
                        <small class="text-muted d-block">Ropani</small>
                    </div>
                    <span class="font-weight-bold mb-3">-</span>
                    <div class="text-center mx-1 flex-fill">
                        <input type="number" min="0" class="form-control text-center p-1" formControlName="aana" (input)="updateHouseArea()" placeholder="0">
                        <small class="text-muted d-block">Aana</small>
                    </div>
                    <span class="font-weight-bold mb-3">-</span>
                    <div class="text-center mx-1 flex-fill">
                        <input type="number" min="0" class="form-control text-center p-1" formControlName="paisa" (input)="updateHouseArea()" placeholder="0">
                        <small class="text-muted d-block">Paisa</small>
                    </div>
                    <span class="font-weight-bold mb-3">-</span>
                    <div class="text-center ml-1 flex-fill">
                        <input type="number" min="0" class="form-control text-center p-1" formControlName="daam" (input)="updateHouseArea()" placeholder="0">
                        <small class="text-muted d-block">Daam</small>
                    </div>
                </div>
            </div>
            <div class="col-md-6 form-group">
                <label for="totalFloors">Total Floors</label>
                <input class="form-control" id="totalFloors" type="number" formControlName="floor" placeholder="Total floors">
            </div>
            <div class="col-sm-6 form-group">
                <label for="price">Price</label>
                <input class="form-control" id="price" type="number" formControlName="price" placeholder="Enter the price of your property">
            </div>
        </form>
    </div>
</div>
<div mat-dialog-actions class="row col-sm-12 justify-content-end">
  <button mat-button mat-dialog-close>Close</button>
  <button mat-button (click)="savePropertyBasicInfo()" cdkFocusInitial>Save</button>
</div>